var exports = {
  "k": "x93eb46d8--1e8e85--container",
};

module.exports = exports;
